import React from 'react';
type Bonus = {
  number: number;
  title: string;
  tagline: string;
  intro: string;
  bullets: string[];
  footer: string;
  image: string;
};
const bonuses: Bonus[] = [{
  number: 1,
  title: 'Banco de Producciones Escritas',
  tagline: '30 propuestas para pensar, argumentar y escribir.',
  intro: 'Incluye actividades sobre:',
  bullets: ['identidad', 'ciudadanía', 'democracia', 'ambiente', 'tecnología', 'convivencia', 'memoria', 'cultura'],
  footer: 'Ideal para trabajar producción escrita durante todo el año.',
  image: 'https://cdn.magicpatterns.com/uploads/tFbzxxKcKVA8JiS1E6Jp5r/bonus_1.png'
}, {
  number: 2,
  title: 'Banco de Debates para Secundaria',
  tagline: 'Temas actuales para dialogar, reflexionar y participar.',
  intro: 'Incluye debates sobre:',
  bullets: ['inteligencia artificial', 'redes sociales', 'democracia', 'ambiente', 'educación', 'tecnología', 'convivencia', 'cultura'],
  footer: 'Listo para usar en cualquier curso.',
  image: 'https://cdn.magicpatterns.com/uploads/dXkkiniJnGdi8d6quT36ye/bonus_2.png'
}, {
  number: 3,
  title: '50 Actividades de Ciudadanía',
  tagline: 'Recursos listos para trabajar en el aula.',
  intro: 'Incluye actividades sobre:',
  bullets: ['participación ciudadana', 'democracia', 'convivencia', 'diversidad', 'derechos humanos', 'ambiente', 'ciudadanía digital', 'solidaridad'],
  footer: 'Ideal para tutorías, proyectos y jornadas escolares.',
  image: 'https://cdn.magicpatterns.com/uploads/nk4dy1Btt9VhLHdJf7KW8C/bonus_3.png'
}, {
  number: 4,
  title: 'Del Aula al Mundo',
  tagline: 'Temas actuales para pensar el presente.',
  intro: 'Incluye:',
  bullets: ['🌎 Inteligencia Artificial', '🌎 Redes Sociales', '🌎 Noticias Falsas', '🌎 Salud Mental', '🌎 Cambio Climático', '🌎 Participación Juvenil', '🌎 Diversidad', '🌎 Profesiones del Futuro'],
  footer: 'Un recurso moderno pensado para conectar la escuela con los desafíos actuales.',
  image: 'https://cdn.magicpatterns.com/uploads/uMHqXchYiWknTPQouTEuup/bonus_4.png'
}];
function BonusRow({
  bonus,
  reverse
}: {
  bonus: Bonus;
  reverse: boolean;
}) {
  return <div className={`flex flex-col ${reverse ? 'md:flex-row-reverse' : 'md:flex-row'} items-center gap-6 rounded-3xl p-6 bg-[#FFF8EF] border border-[#F0D3AE]`} data-id="element-34" data-mp="1c4u09k9nmfek">
      <div className="w-full md:w-1/2 flex justify-center" data-id="element-35" data-mp="1q1zalwgei0fm">
        <img src={bonus.image} alt={`Bonus ${bonus.number}: ${bonus.title}`} className="w-[280px] max-w-full h-auto object-contain drop-shadow-xl" data-id="element-36" data-mp="1m3tah7a2ij3o" />
      </div>

      <div className="w-full md:w-1/2" data-id="element-37" data-mp="te2t8pd5313c">
        <span className="inline-block bg-[#E0872F] text-white text-[10px] font-black tracking-wide px-3 py-1 rounded-full mb-3 uppercase" data-id="element-38" data-mp="tf44atu5nnl2">
          🎁 Bonus {bonus.number}
        </span>
        <h3 className="text-xl md:text-2xl font-black mb-2 text-[#1B3A6B] leading-tight" data-id="element-39" data-mp="12dg49mgwvxq6">
          {bonus.title}
        </h3>
        <p className="text-lg text-gray-700 mb-4" data-id="element-40" data-mp="en3ppsr5v2qm">{bonus.tagline}</p>
        <p className="text-sm font-bold text-gray-500 uppercase tracking-wide mb-2" data-id="element-41" data-mp="ama1szdpxnxq">
          {bonus.intro}
        </p>
        <ul className="grid grid-cols-2 gap-x-3 gap-y-1.5 text-base text-gray-800 mb-4" data-id="element-42" data-mp="htnwbjsugwk">
          {bonus.bullets.map(item => <li key={item} className="flex items-start" data-id="element-43" data-mp="5c7l8ji0uy3v">
              <span className="text-[#E0872F] mr-2 font-bold" data-id="element-44" data-mp="3mrntstj7031b">✔</span>
              {item}
            </li>)}
        </ul>
        <p className="text-base font-bold text-gray-900" data-id="element-45" data-mp="3rq7giw5m1iuq">{bonus.footer}</p>
      </div>
    </div>;
}
export function BonusSection() {
  return <section className="py-10 px-4 bg-white" data-id="element-46" data-mp="j81ho31lzv03">
      <div className="max-w-5xl mx-auto" data-id="element-47" data-mp="o7xqcfl94alz">
        <div className="text-center mb-8" data-id="element-48" data-mp="o6mm6enw90uc">
          <h2 className="text-[20px] md:text-2xl font-black mb-3 text-[#1B3A6B] uppercase" data-id="element-49" data-mp="9chovpicdcfk">
            Además recibís estos bonus
          </h2>
          <div className="inline-block bg-red-600 text-white text-base md:text-lg font-black px-6 py-2 rounded-full shadow-lg" data-id="element-50" data-mp="ecw1lkuw1ajx">
            🎁 GRATIS POR EL DÍA DE HOY
          </div>
        </div>

        <div className="space-y-6" data-id="element-51" data-mp="2yyxj0nn0zpsm">
          {bonuses.map((bonus, index) => <BonusRow key={bonus.number} bonus={bonus} reverse={index % 2 === 1} data-id="element-52" data-mp="3f8ycehqrlpac" data-mpi={index} />)}
        </div>
      </div>
    </section>;
}